import React, { FC } from "react"
import { View } from "react-native"
import { CalendarItemType, CheckListItem } from "../../models"
import { Checkbox } from "../Checkbox/Checkbox"

interface ChecklistProps {
  itemId?: string
  itemType?: CalendarItemType
  checklist: CheckListItem[]
  onChecklistPress?: (data: {
    item: { id?: string; type?: string }
    checklist: CheckListItem
  }) => void
}

const Checklist: FC<ChecklistProps> = ({ itemId, itemType, checklist, onChecklistPress }) => {
  return (
    <View>
      {checklist.map((checklistItem) => (
        <Checkbox
          key={checklistItem.id}
          preset="circle"
          label={checklistItem.title?.replace(/(?:^|(?:[.!?]\s?))(\w)/, (val)=>val.toUpperCase())}
          value={checklistItem.checked}
          onChange={(newVal) => {
            onChecklistPress &&
              onChecklistPress({
                item: {
                  id: itemId,
                  type: itemType,
                },
                checklist: { ...checklistItem, checked: newVal },
              })
          }}
        />
      ))}
    </View>
  )
}

export default Checklist
